<template>
  <div class="main-content queryBilling">
    <search-item
      :key="identify"
      :ref="identify"
      :show-more-scheme="true"
      :show-simple="showSimple"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :grid-config-module="gridConfigModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      :is-append-query="isAppendQuery"
      :col-settings="colSettings"
      @query="fetchData"
      @advToggle="scrollCallback"
      @perConfigChange="value=>{perConfigName=value}"
      @refreshGrid="()=>{gridRefreshId+=1}"
      @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid-wrapper
        :config-module="gridConfigModule"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="dynamicColumnDefs"
        :sum-column-defs="sumColumnDefs"
        :row-data="rowData"
        :min-height="hasVoucher===0?'350px':'200px'"
        :show-row-groups="dataListDragGroup"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
    <div id="footer-wrapper-tab-billing" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-if="dataShow && ['tabBilling', 'Writeoff'].includes(viewSource)" v-text="totalAmountToCurrencyBillingGrid.labelText" />
        <span v-if="dataShow && ['tabBilling', 'Writeoff', 'VoucherList'].includes(viewSource)" v-text="totalAmountToCurrencyBillingGrid.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc && ['tabBilling', 'Writeoff', 'VoucherList'].includes(viewSource)"
          :key="1"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyBillingGrid.dataProvider"
          :data-field="totalDataField"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :show-wht="showWht"
        />
        <span v-if="showTotalUnverifiedAmount && ['tabBilling', 'Writeoff'].includes(viewSource)" v-text="totalAmountNotWrittenOffLabel" />
        <charge-currency-total-group
          v-if="reCalc && showTotalUnverifiedAmount && ['tabBilling', 'Writeoff'].includes(viewSource)"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyBillingGrid.dataProvider"
          data-field="unverifiedAmount"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :show-wht="showWht"
        />
        <charge-count-group
          v-if="reCalc && ['MakeInvoice'].includes(viewSource)"
          :key="3"
          :selected-count="totalAmountToCurrencyBillingGrid.selectedCount"
          :data-provider="totalAmountToCurrencyBillingGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyBillingGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="true"
        />
        <charge-sum-by-currency
          v-if="reCalc && ['tabBilling'].includes(viewSource)"
          :key="4"
          :data-provider="totalAmountToCurrencyBillingGrid.dataProvider"
        />
      </div>
      <div v-show="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.total"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="!appendQuery"
        ref="paginationBilling"
        :config-module="gridConfigModule"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <!-- 开票申请审批流 -->
    <!-- 账单弹窗 -->
    <bill-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      ref="billDialog"
      :is-bpm="true"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      :visible.sync="workFlowApplyDialog.visible"
      :billing-uuid="workFlowApplyDialog.documentProcess.docId"
      :is-view="true"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible=false
        fetchDataByPage()
      }"
    />
    <push-log-dialog-ql
      v-if="pushLogDialog.visible"
      :visible.sync="pushLogDialog.visible"
      :uuid="pushLogDialog.uuid"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import ChargeSumByCurrency from '@/components/Cargo/Act/chargeSummary/ChargeSumByCurrency'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import { DocumentManage, ensureExecuteSuccess, Once, stringToBool } from '@/utils/commonUtil'
import { getBillingList, simpleQueryBillingList } from '@/api/clearing/billingNative'
import lodash from 'lodash'
import moment from 'moment'
import { formatNumberToThousands } from '@/utils'
import StrUtils from '@/utils/StrUtils'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import { getBankAccountList } from '@/api/bankAccount'
import BillWorkFlowApplyDialog from '@/components/Cargo/Act/billDialog'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import { Job_CHARGE, MAKE_INVOICE, MAKE_INVOICE_BILLING } from '@/class/cargo/model/parameters/WorkflowConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import { isNumber2 } from '@/utils/validate'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import pushLogDialogQl from '@/views/cargo/v0/Clearing/components/SharedCenter/pushLogDialogQl'

export default {
  name: 'QueryBilling',
  components: { searchItem, ChargeCountGroup, ChargeCurrencyTotalGroup, ChargeSumByCurrency, BillWorkFlowApplyDialog, cargoAgGridWrapper, pushLogDialogQl },
  props: {
    identify: { type: String, required: true, default: 'queryBilling' }, // ID
    viewSource: { type: String, required: true, default: 'tabBilling' }, // 引用页面
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外 2:代理分成账单
    advance: { type: Number, default: -1 }, // 是否垫付
    isNeedInvoice: { type: Number, default: -1 }, // 是否需要开票
    hasInvoice: { type: Number, default: -1 }, // 是否开票
    hasBillingGroup: { type: Number, default: -1 }, // 是否有BillingGroup
    clearingState: { type: Number, default: -1 }, // 核销状态：0:有未销账；1:有已销账；2:全部销完
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    showUninvoiceAmount: { type: Boolean, default: false }, // 是否显示未开票金额
    showVoucherDate: { type: Boolean, default: false }, // 显示生成凭证日期
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    showInvoiceNo: { type: Boolean, default: false }, // 显示发票号
    showFba: { type: Boolean, default: false }, // 显示FBA相关列
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    exceptAdvancedSearchOption: { type: Object, default: null },
    accountId: { type: Number, default: 0 }, // 对冲开票结算单位
    billingStateParam: { type: String, default: 'BillingState' }, // BillingState, 对账-对账-账单状态查询(对账)
    billingClearingStateParam: { type: String, default: 'BillingClearingState' }, // BillingClearingState, 对账-对账单-对账单核销状态查询(对账)
    billingJobStateParam: { type: String, default: 'BillingJobState' }, // BillingJobState, 对账-费用-业务状态查询(对账)
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'rate' }, // 汇率字段
    arField: { type: String, default: 'ar' }, // 收付字段
    type: { type: String, default: 'revenueAbs', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    configModule: { type: String, default: '504' }, // 高级查询条件
    gridConfigModule: { type: String, default: '190903' }, // 列表设置
    writeoffHasInvoice: { type: Number, default: -1 }, // 销账-是否已开票(销账)
    invoiceHasBillPayment: { type: Number, default: -1 }, // 是否已申请付款(销账)
    hasCheckRole: { type: Boolean, default: false }, // 是否根据权限查询数据 【为销账列表默认false，对账是 true】
    showSimple: { type: Boolean, default: true },
    isExt: { type: Boolean, default: false },
    accountSetKey: { type: String, default: '' }, // 账套uuid
    hasVoucher: { type: Number, default: -1 }, // 是否已经生成过凭证:1=是,0=否
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    colSettings: { type: Object },
    internalCharge: { type: Boolean, default: false }, // 内结
    accountSetBranchId: { type: Number, default: 0 }, // 账套branchId
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '按账单查询',
      // configModule: '504',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchBillNumber'),
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onSelectionChanged: this.toRefreshSelectedCount,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked,
        autoGroupColumnDef: {
          headerName: this.$t('Message.DataGroup'),
          field: 'autoColumn',
          minWidth: 220,
          comparator: (a, b) => {
            if (typeof a === 'string' && typeof b === 'string') {
              if (a && b) {
                const newA = a.replaceAll(',', '')
                const newB = b.replaceAll(',', '')
                if (isNumber2(newA) && isNumber2(newB)) {
                  a = Number(newA)
                  b = Number(newB)
                }
              }
              if (a && b && typeof a === 'number' && typeof b === 'number') {
                if (!isNaN(a) && !isNaN(b)) {
                  return a - b
                }
              }
              for (let i = 0; i < a.length && i < b.length; ++i) {
                const aCode = a.charCodeAt(i)
                const bCode = b.charCodeAt(i)
                const diff = aCode >= 256 && bCode >= 256 ? a[i].localeCompare(b[i], 'zh') : aCode - bCode
                if (diff !== 0) {
                  return diff
                }
              }
              return a.length - b.length
            }
            if (a === b) {
              return 0
            } else if (a < b) {
              return -1
            } else {
              return 1
            }
          }
        }
      },
      gridApi: null,
      columnDefs: [],
      defaultSearchItems: [],
      sumColumnDefs: [
        {
          field: 'amount',
          getValue: data => data.amount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(value)), 2)
        },
        {
          field: 'verifiedAmount',
          getValue: data => data.verifiedAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(value)), 2)
        },
        {
          field: 'uninvoiceAmount',
          getValue: data => data.uninvoiceAmount,
          format: value => formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(value)), 2)
        }
      ],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: [],
        jobStates: [], // 业务状态
        billingStates: [], // 账单状态
        clearingStates: [] // 核销状态
      },
      bankList: [],
      showLoading: true, // 是否显示加载中样式
      totalAmountToCurrencyBillingGrid: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      selectedItem: null, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      queryOfficeId: 0, // 记录查询时的分公司Id
      updateRows: false,
      appendQuery: false, // 追加查询
      newInvoiceTypesOfBilling: false, // 是否国内账单发票类型客户化(成基)
      toExoSystemOC: false, // 是否橙联推送
      toExoSystemTp: false,
      workFlowApplyDialog: {
        visible: false
      },
      documentManage: new DocumentManage(),
      isBpmEnabled: false,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      vocherAllowedQueryDomesticBilling: false, // CARGO-47698 生成凭证，在按账单模式下，是否可查询国内账单。
      qlToFinanceApi: false,
      pushLogDialog: {
        visible: false,
        uuid: ''
      }
    }
  },
  computed: {
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    // 公用显示列
    dynamicColumnDefs() {
      const columnDefs = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Billing.billingJob_billNo'), field: 'billingNo', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_accountStatementNo'), field: 'billingGroupBillingNo', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_settlementAgent'), field: 'settlementAgentId', width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
          },
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_agentBillNo'), field: 'counterPartyBillingNo', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_invoiceNo'), field: 'invoiceNo', width: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('Billing.billingView_billType'), field: 'billingType', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.billingTypeLabFun(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'ar', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_billDate'), field: 'inputDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DueDate'),
          field: 'dueDate',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_invoiceHeader'), field: 'title', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_invoicingRequirements'), field: 'invoiceDemand', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_settleAccountsTo'), field: 'accountId', width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_solicitationType'), field: 'jobCargoSource', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('Partners.isFba'),
          colId: 'fba',
          field: 'fba',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          colId: 'warehouseCode',
          field: 'warehouseCode',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('FbaJob.DestinationDistribution'),
          colId: 'destinationDistribution',
          field: 'destinationDistribution',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('FbaJob.ExpressNo'),
          colId: 'expressNo',
          field: 'expressNo',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('FbaJob.RemoteWarehouse'),
          colId: 'remoteWarehouse',
          field: 'remoteWarehouse',
          width: 180,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: 'Shipment Id',
          colId: 'shipmentId',
          field: 'shipmentId',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: 'Reference Id',
          colId: 'referenceId',
          field: 'referenceId',
          width: 180,
          hide: true,
          enableRowGroup: true
        },
        { headerName: 'ETD', field: 'jobEtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: 'ETA', field: 'jobEta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_confirmDate'), field: 'billingConfirmDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_proofDate'), field: 'voucherExportDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: !this.showVoucherDate,
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_businessNumber'), field: 'jobNo', width: 200,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              if (!params.data) {
                return {}
              }
              const data = params.data
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                }
              }
            }
          }
        },
        { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobHbl', width: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_mblNo'), field: 'jobMbl', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_vesselAndVoyage'), field: 'voyageFlight', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_portOfLoading'), field: 'pol', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.portAutoKeyLabelFunc(params.value, params.data.lob)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.portAutoKeyLabelFunc(params.data.pol, params.data.lob)
          }
        },
        { headerName: this.$t('Billing.billingJob_portOfDestination'), field: 'pod2', width: 200,
          cellRenderer: (params) => {
            const value = params.pod2 || params.data.pod
            return ColumnUtils.portAutoKeyLabelFunc(value, params.data.lob)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            const value = params.data ? (params.data.pod2 || params.data.pod) : ''
            return value ? ColumnUtils.portAutoKeyLabelFunc(value, params.data.lob) : ''
          }
        },
        { headerName: this.$t('Billing.billingJob_creator'), field: 'inputBy', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_customerService'), field: 'jobCsr', width: 200, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_customJobType'), field: 'jobCustomJobType', width: 200,
          valueGetter: (params) => {
            return ColumnUtils.resolveCutomJobTypeLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.data.jobCustomJobType, 'name', params.data.lob, params.data.fba)
          },
          hide: true,
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_billStatus'), field: 'state', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.billingStateLabelFun(Number(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_invoicingStatus'), field: 'invoiceState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceStateLabelFun(Number(params.value))
          },
          hide: !this.showInvoiceState,
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_writeOffStatus'), field: 'realClearingState', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(Number(params.value))
          },
          hide: !this.showRealClearingState,
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_currency'), field: 'currency', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_amountOfMoney'), field: 'amount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('Billing.billingJob_aging'), field: 'aging', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_theAmountOfWriteOffs'), field: 'verifiedAmount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
          },
          hide: !this.showVerifiedAmount,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('Billing.billingJob_notInvoicedMoney'), field: 'uninvoiceAmount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
          },
          hide: !this.showUnInvoiceAmount,
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        { headerName: this.$t('Billing.billingJob_totalCurrency'), field: 'currencyAmount', width: 200, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('Billing.billingJob_remarks'), field: 'remark', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_bookingNo'), field: 'bookingNo', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_markDate'), field: 'markDate', width: 200, enableRowGroup: true },
        { headerName: this.$t('Billing.billingJob_markUser'), field: 'markUser', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_markStatus'), field: 'mark', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.markingStateLabelFun(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Billing.billingJob_theAmountOfNotWriteOffs'), field: 'unverifiedAmount', width: 200,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(Number(params.value)), 2)
          },
          enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('Billing.billingJob_sales'),
          field: 'sales',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Billing.billingCharge_consignationCompany'),
          field: 'customerId',
          width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.customerLabelFunc(params.data) ? ColumnUtils.customerLabelFunc(params.data) : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: 'ATD', field: 'jobAtd', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: 'ATA', field: 'jobAta', width: 120, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 120, hide: true, enableRowGroup: true
        },
        {
          headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'invoiceMakeType', colId: 'invoiceMakeType', width: 120, hide: true, enableRowGroup: true
        }, {
          headerName: this.$t('SeaExport.ContainerNo'),
          field: 'jobContainerNo',
          initialWidth: 150,
          cellRenderer: (params) => {
            while (true) {
              params.value = params.value.replace(',,', ',')
              if (params.value.indexOf(',') === 0) {
                params.value = params.value.substring(1, params.value.length)
              } else if (params.value.substring(params.value.length - 1, params.value.length) == ',') {
                params.value = params.value.substring(0, params.value.length - 1)
              } else {
                break
              }
            }
            return params.value
          },
          hide: true
        },
        { headerName: this.$t('Billing.billingCharge_operation'), field: 'jobOp', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('CargoMsg.Carge_BillingConfirmUser'),
          field: 'billingConfirmUser',
          initialWidth: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('queryJob.placeOfDelivery'), field: 'destinationPlace', initialWidth: 200, hide: true, enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvalidOrNot'),
          field: 'revoked',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ConfirmOrNot'), field: 'confirmed', colId: 'confirmed', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('SeaExport.CustomerLevel'),
          colId: 'customerTypeId',
          field: 'customerTypeId',
          width: 150,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.customerTypeLabelFunc(params.data) ? ColumnUtils.customerTypeLabelFunc(params.data) : ColumnUtils.companyCustomerTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.BookingAgent'),
          colId: 'bookingAgent',
          field: 'bookingAgent',
          width: 150,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.bookingAgentLabelFunc(params.data) ? ColumnUtils.bookingAgentLabelFunc(params.data) : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('SeaExport.ConsignationRelationNumber'), colId: 'trustFromJob', field: 'trustFromJob', hide: true, width: 120, enableRowGroup: true },
        { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), colId: 'relatedJob', field: 'relatedJob', hide: true, width: 120, enableRowGroup: true },
        {
          headerName: this.$t('CargoMsg.Cargo_LockedOrNot'), field: 'ocPaymentLock', hide: true, width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OcPrePayment'), field: 'prePayment', hide: !this.toExoSystemOC, width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.businessReferenceNumber'),
          colId: 'jobCustomerRefNo',
          field: 'jobCustomerRefNo',
          width: 150,
          enableRowGroup: true
        }, {
          headerName: this.$t('Billing.billingJob_otherPartyBilling'),
          field: 'otherPartyBilling',
          colId: 'otherPartyBilling',
          hide: true,
          width: 150,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Message.SettlementObjectAccountPeriod'),
          field: 'creditDateLimited',
          width: 100,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementMethod'),
          field: 'creditDateType',
          width: 100,
          hide: true,
          valueFormatter: params => {
            return ColumnUtils.creditDateTypeCommonLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('Billing.billing_recheckStatus'),
          field: 'review',
          colId: 'review',
          hide: true,
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.billingReviewLabelFunc(Number(params.value))
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('Billing.billing_reviewPeople'),
          field: 'reviewBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('Billing.billing_reviewDate'),
          field: 'reviewDate',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'jobCarrierId', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
          field: 'jobDispatchingPlace',
          colId: 'jobDispatchingPlace',
          width: 120,
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
          field: 'actTakeTime',
          colId: 'actTakeTime',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OurBank'),
          field: 'bankAccountId',
          colId: 'bankAccountId',
          width: 120,
          hide: true,
          cellRenderer: (params) => {
            return this.revertBankName(params)
          }
        },
        {
          headerName: this.$t('SeaExport.OperationDate'), field: 'jobCustomsDate', initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'jobPono', initialWidth: 120, enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.DeliveryCompletionDate'), initialWidth: 150,
          field: 'jobDeliveryCompletionDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          },
          enableRowGroup: true
        }, {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementType',
          initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypeLableFun(Number(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Partners.ParentCompany'), field: 'globalAccountUuid', width: 200,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'uuid', params.value, 'auto_accountId') : ''
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_remarkAddContent2'), field: 'remarkAddContent', width: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_detailMakeInvoice2'), field: 'detailMakeInvoice', width: 100, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_splitMakeInvoice2'), field: 'splitMakeInvoice', width: 100, hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          },
          enableRowGroup: true
        },
        { headerName: this.$t('CargoMsg.Cargo_rmbGoodsName'), field: 'rmbGoodsName', width: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_usdGoodsName'), field: 'usdGoodsName', width: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'jobBusinessDate', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'fcAuditDate', width: 200,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          enableRowGroup: true
        },
        { headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'notWhtAmount',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('SeaExport.DeliveryTime'), field: 'jobDestPortDeliveryTime', initialWidth: 200, hide: true },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessModel'),
          field: 'containerLoadType',
          colId: 'containerLoadType',
          cellRenderer: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunctionForAllBusiness(params.data, 'containerLoadType')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunctionForAllBusiness(params.data, 'containerLoadType')
          },
          hide: true,
          width: 150
        },
        {
          headerName: 'SERVICE',
          field: 'whtService',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'ADVANCE',
          field: 'whtAdvance',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ContainsAdvancePayment'),
          field: 'advanceCount',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value > 0))
          },
          hide: false,
          enableRowGroup: true
        },
        {
          headerName: 'VAT',
          field: 'whtVat',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('Billing.InvalidDate'),
          field: 'invalidDate',
          width: 120,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_VoidedBy'), field: 'invalidBy', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          },
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: this.$t('Message.SettlementObjectAccountCredit'),
          field: 'credit',
          width: 100,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.creditCommonLabelFunc(params.data)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PushLog'), field: 'feedbackState', hide: true, width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            if (params.data.state !== 1) {
              const uuid = params.data.uuid
              const methodOnFileViewPath = this.documentManage.getPath('onView')
              return `<a onclick="${methodOnFileViewPath}('${uuid}')" style="color:blue">
                    ${this.$t('CargoMsg.Cargo_View')}
                    </a>`
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('SeaExport.UserDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.UserDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_InputDate'), field: 'billingGroupInputDate', initialWidth: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true,
          enableRowGroup: true
        }
      ]
      if (this.isBpmEnabled) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
          field: 'documentProcessNo',
          colId: 'documentProcessNo',
          width: 200,
          hide: true,
          excelRenderer: (params) => {
            if (params.value) {
              return params.value
            }
            return ''
          },
          cellRenderer: (params) => {
            if (params.value) {
              const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
              return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
            }
            return ''
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.documentProcessNo ? params.data.documentProcessNo : ''
          }
        })
      }
      if (this.oversea === 1) {
        columnDefs.push({
          headerName: this.$t('Billing.ForeignInvoiceTime'),
          field: 'overseaInvoiceDate',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        })
      }

      if (this.qlToFinanceApi) {
        columnDefs.push(
          {
            headerName: this.$t('Clearing.SyncCloudPlatformStatus'),
            field: 'syncExternalStatus',
            initialWidth: 100,
            valueFormatter: (params) => {
              return ColumnUtils.hmYongYouSyncStatusLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('FinanceManage.SyncExceptionReason'),
            field: 'syncExternalFailReason',
            initialWidth: 200
          }
        )
      }

      if (this.toExoSystemTp) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_ExportBillVoucherStatus'),
          field: 'exportAccpacOverseasBilling',
          width: 200,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        })
      }
      return columnDefs
    },
    totalAmountNotWrittenOffLabel() {
      if (this.totalAmountToCurrencyBillingGrid.dataProvider.length > 0) {
        return this.$t('Billing.billingJob_totalAmountNotWrittenOff')
      } else {
        return ''
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        this.qlToFinanceApi = cache.config.get('ToFinanceApi') === 'QL' // 青旅202507
        await this.initCustomSearchItems()
      }
    }

  },
  async created() {
    this.selectedItem = null
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
    await this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, 'workFlowApplyDialog', documentProcessId)
    })
    this.documentManage.set('onView', function(value) {
      context.onView(value)
    })
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    // 配置参数
    async initConfig() {
      this.newInvoiceTypesOfBilling = Number(cache.config.get('newInvoiceTypesOfBilling')) === 1
      this.toExoSystemOC = Number(cache.config.get('ToExoSystem')) === 2
      this.toExoSystemTp = String(cache.config.get('ToExoSystem')) === 'TP'
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.isBpmEnabled = await WorkflowUtil.isBpmEnabled({
        documentConfigId: MAKE_INVOICE.code,
        officeId: this.$store.getters.currentOfficeId,
        formSubtype: MAKE_INVOICE_BILLING.code
      })
      this.vocherAllowedQueryDomesticBilling = Number(cache.config.get('VocherAllowedQueryDomesticBilling')) === 1
    },
    // 转换银行名
    revertBankName(params) {
      if (this.bankList) {
        for (let i = 0; i < this.bankList.length; i++) {
          const bankAccount = this.bankList[i]
          if (bankAccount['currency'] === params.data.currency) {
            if (bankAccount['accountId'] === params.data.bankAccountId) {
              // 获取当前的id
              return this.$store.getters.language === 'zh' ? bankAccount['bankChineseName'] : bankAccount['bankEnglishName']
            }
          }
        }
      }
    },

    // 查询
    fetchData({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      // this.tabBillingHp.fetchData({ simpleTriggerMode, conditions })
      const finallyConditions = []
      if (simpleTriggerMode) {
        this.appendQuery = false
        if (['tabBilling', 'Writeoff'].includes(this.viewSource)) {
          const option = new AdvancedSearchOption(null, 'billing.BILLINGNO', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
          finallyConditions.push(option.formatObj2Json())
        }
      } else {
        // 高级查询条件组装
        if (conditions && conditions.length > 0) {
          const advConditions = lodash.cloneDeep(conditions)
          // 获取追加查询条件
          this.appendQuery = JobUtils.appendQueryCondition(advConditions)
          finallyConditions.push(...advConditions)
        }
      }
      // 是否查询受控费用
      if (this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      // 结算单位
      if (this.accountId > 0 && !AdvancedSearchOption.hasField('billing.ACCOUNTID', conditions)) {
        const option = new AdvancedSearchOption(null, 'billing.ACCOUNTID', this.accountId, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      this.showLoading = true
      this.searchConditions.snapshotConditions = lodash.cloneDeep(finallyConditions)

      // // 获取当前分公司
      // const param = {'office': this.$store.getters.officeID}
      // finallyConditions.push()

      this.toAdvQueryList(finallyConditions, simpleTriggerMode)
    },
    // 分页触发查询
    fetchDataByPage() {
      this.showLoading = true
      this.toAdvQueryList(this.searchConditions.snapshotConditions)
    },
    // 拼接查询条件并发起请求
    async toAdvQueryList(conditions, simpleTriggerMode = false, isUpdate = false) {
      this.updateRows = isUpdate
      this.queryOfficeId = this.$store.getters.currentOfficeId
      await cache.load(cacheName.CONFIG)
      // 拼接默认的查询条件
      const searchConditions = this.searchConditions
      // if (this.viewSource !== 'VoucherList') {
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      } else if (!this.inputDateStart && this.inputDateEnd) {
        inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, 'billing.INPUTDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        conditions.push(condition.formatObj2Json())
      }
      // }
      if (this.isAr !== -1) {
        const condition = new AdvancedSearchOption(null, 'billing.AR', this.isAr === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.advance !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.ADVANCE', this.advance === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.isNeedInvoice !== -1) {
        const condition = new AdvancedSearchOption(null, 'charge.NEED_INVOICE', this.isNeedInvoice === 1, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.hasInvoice !== -1 && !AdvancedSearchOption.hasField('charge.INVOICE_UUID', conditions) && !AdvancedSearchOption.hasField('invoice.INVOICEDATE', conditions)) {
        const operator = this.hasInvoice === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(null, 'charge.INVOICE_UUID', null, operator)
        conditions.push(condition.formatObj2Json())
      }
      if (this.hasVoucher === -1) {
        if (this.oversea === 0) {
          const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', '国内账单', OperatorConstants.OPERATOR_EQUAL.code)
          conditions.push(condition.formatObj2Json())
        } else if (this.oversea === 1) {
          const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', '国外账单', OperatorConstants.OPERATOR_EQUAL.code)
          conditions.push(condition.formatObj2Json())
        } else if (this.oversea === 2) {
          if (AdvancedSearchOption.hasField('billing.BILLINGTYPE', conditions)) {
            for (const item of conditions) {
              if (item.fieldName === 'billing.BILLINGTYPE') {
                if (item.operator === OperatorConstants.OPERATOR_EQUAL.code) {
                  if (item.value === '国外账单') {
                    item.operator = OperatorConstants.OPERATOR_IN.code
                    item.value = ['国外账单', '代理分成账单']
                  } else {
                    item.value = '代理分成账单'
                  }
                }
                break
              }
            }
          } else {
            const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', '代理分成账单', OperatorConstants.OPERATOR_EQUAL.code)
            conditions.push(condition.formatObj2Json())
          }
        } else {
          const condition = new AdvancedSearchOption(null, 'billing.BILLINGTYPE', ['国外账单', '国内账单'], OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      } else {
        if (this.oversea === 0) {
          conditions.push(new AdvancedSearchOption(null, 'billing.BILLINGTYPE', BillingConstants.BILLING_TYPE_INTERNAL.code, OperatorConstants.OPERATOR_EQUAL.code).formatObj2Json())
        } else if (this.oversea === 1) {
          if (this.vocherAllowedQueryDomesticBilling) {
            conditions.push(new AdvancedSearchOption(null, 'billing.BILLINGTYPE', [BillingConstants.BILLING_TYPE_INTERNAL.code, BillingConstants.BILLING_TYPE_OVERSEA.code, BillingConstants.BILLING_TYPE_NORMAL.code], OperatorConstants.OPERATOR_IN.code).formatObj2Json())
          } else {
            conditions.push(new AdvancedSearchOption(null, 'billing.BILLINGTYPE', [BillingConstants.BILLING_TYPE_OVERSEA.code, BillingConstants.BILLING_TYPE_NORMAL.code], OperatorConstants.OPERATOR_IN.code).formatObj2Json())
          }
        }
      }
      // 是否生成凭证
      if (this.hasVoucher !== -1 && !StrUtils.isEmpty(this.accountSetKey)) {
        conditions.push(new AdvancedSearchOption(null, SpecialFieldConstants.BILLING_VOUCHERED_NATIVE, { 'accountSetKey': this.accountSetKey }, this.hasVoucher === 1 ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
      }
      // 账单状态
      if (!AdvancedSearchOption.hasField('billing.STATE', conditions)) {
        if (searchConditions.billingStates && searchConditions.billingStates.length > 0) {
          const billingStateArray = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.billingStates)
          const condition = new AdvancedSearchOption(null, 'billing.STATE', billingStateArray, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        } else {
          // const condition = new AdvancedSearchOption(null, 'billing.STATE', 3, OperatorConstants.OPERATOR_UNEQUAL.code)
          const condition = new AdvancedSearchOption(null, 'billing.STATE', [-1, 0, 1, 2, 4, 5, 11], OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        if (searchConditions.jobStates && searchConditions.jobStates.length > 0) {
          const jobStates = LoadDefaultQueryParam.convertCommonStateToInt(searchConditions.jobStates)
          const condition = new AdvancedSearchOption(null, 'job.JOB_STATE', jobStates, OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      // 核销状态 0:有未销账 1:有已销账 2:全部销完
      if (this.clearingState !== -1) {
        if (this.clearingState === ClearingConstants.CLEARING_STATE_NON.code || this.clearingState === ClearingConstants.CLEARING_STATE_PARTIAL.code) {
          const condition = new AdvancedSearchOption(null, 'charge.PAID_OFF', false, OperatorConstants.OPERATOR_EQUAL.code)
          conditions.push(condition.formatObj2Json())
        } else if (this.clearingState === ClearingConstants.CLEARING_STATE_FULL.code) {
          // CARGO-20734，生成凭证：根据海外账单生成凭证，检索不到海外账单
          // const condition = new AdvancedSearchOption(null, 'billing.CLEARING_STATE', 2, OperatorConstants.OPERATOR_EQUAL.code)
          const condition = new AdvancedSearchOption(null, 'billing._BILL_WRITE_OFF_STATUS', [BillingConstants.ALL_VERIFICATION.code], OperatorConstants.OPERATOR_IN.code)
          conditions.push(condition.formatObj2Json())
        }
      }
      if (this.selectedEntitiesForHedging && this.selectedEntitiesForHedging.length > 0) {
        const condition = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', this.selectedEntitiesForHedging)
        conditions.push(condition.formatObj2Json())
      }
      if (this.exceptKeys.length > 0) {
        const condition = new AdvancedSearchOption(null, 'billing.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        conditions.push(condition.formatObj2Json())
      }
      if (this.exceptAdvancedSearchOption) {
        conditions.push(this.exceptAdvancedSearchOption.formatObj2Json())
      }
      const isAging = AdvancedSearchOption.getOption('billing.ETD', conditions)
      if (isAging) {
        const day = isAging.value
        const nowDate = new Date()
        const searcherDate = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate() - day)
        isAging.value = searcherDate.getFullYear() + '-' + (Number(searcherDate.getMonth()) + 1) + '-' + searcherDate.getDay()
        const condition = new AdvancedSearchOption(isAging.fieldType, isAging.fieldName, isAging.value, isAging.operator)
        AdvancedSearchOption.removeOption(isAging.fieldName, conditions)
        conditions.push(condition.formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        conditions.push(condition.formatObj2Json())
      }

      const requires = []
      if (this.showVerifiedAmount || this.showRealClearingState) { requires.push('writeoff') }
      if (this.showInvoiceState || this.showUninvoiceAmount) { requires.push('invoice') }
      if (this.showVoucherDate || this.hasVoucher === 1) { requires.push('voucherDate') }
      if (this.showInvoiceNo) { requires.push('invoiceNo') }
      if (this.viewSource === 'Writeoff') { requires.push('OCWriteOff') }
      if (this.showFba) { requires.push('fba') }
      if (this.showWhtTax) { requires.push('whtTax') }

      if (this.qlToFinanceApi) {
        requires.push('qlToFinanceApi')
      }

      const requestBody = { conditions, requires: requires, branchId: (this.accountSetBranchId ? this.accountSetBranchId : this.$store.getters.currentOfficeId), pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, hasCheckRole: this.hasCheckRole }
      requestBody.appendQuery = this.appendQuery
      if (this.showLoading) {
        this.loading = getLoading()
      }
      if (simpleTriggerMode) { // 是否快捷查询
        const selectedStatus = recordSelectedStatus(this.gridApi, 'uuid')
        simpleQueryBillingList(requestBody).then(res => {
          if (['tabBilling', 'Writeoff'].includes(this.viewSource)) {
            this.handleBillingResult(res)
          } else {
            this.handleInvoiceResult(res)
          }
        }).finally(() => {
          if (this.showLoading) {
            this.loading.close()
          }
          selectedStatus.revert()
        })
      } else {
        const selectedStatus = recordSelectedStatus(this.gridApi, 'uuid')
        if (this.isBpmEnabled) {
          requestBody.requires = [...requestBody.requires, 'bpm']
        }
        getBillingList(requestBody).then(res => {
          if (['tabBilling', 'Writeoff'].includes(this.viewSource)) {
            this.handleBillingResult(res)
          } else {
            this.handleInvoiceResult(res)
          }
        }).finally(() => {
          if (this.showLoading) {
            this.loading.close()
          }
          selectedStatus.revert()
        })
      }
      if (this.viewSource === 'tabBilling') {
        this.selectedItem = null
        if (this.gridApi) {
          this.gridApi.clearFocusedCell()
        }
      }
    },
    // 对账新版-账单查询结果及处理
    handleBillingResult(res) {
      let results = res.data.list
      if (results && results.length > 0) {
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        }
        if (this.updateRows) {
          const { rowsToDisplay } = this.gridOptions.api.getModel()
          rowsToDisplay.forEach(node => {
            if (!node.data) {
              return
            }
            node.setSelected(false)
            const { data } = node
            const newData = results.find(row => row.uuid === data.uuid)
            if (newData) {
              node.setData(newData)
            } else {
              this.gridOptions.api.updateRowData({ remove: [node.data] })
            }
          })
          results.forEach(item => {
            const newData = rowsToDisplay.find(row => row.data && row.data.uuid === item.uuid)
            if (!newData) {
              this.gridOptions.api.updateRowData({ add: [item] })
            }
          })
          this.updateRows = false
        } else {
          this.rowData = results
        }
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        if (this.isAr === -1) {
          this.totalAmountToCurrencyBillingGrid.labelText = this.$t('Message.All2')
        } else if (this.isAr === 0) {
          this.totalAmountToCurrencyBillingGrid.labelText = this.$t('Clearing.Payable')
        } else if (this.isAr === 1) {
          this.totalAmountToCurrencyBillingGrid.labelText = this.$t('Clearing.Receivable')
        }
        this.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGrid.dataProvider = results
      } else {
        if (this.appendQuery) return
        this.rowData = []
        this.searchConditions.total = 0
        this.totalAmountToCurrencyBillingGrid.labelText = ''
        this.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGrid.dataProvider = []
      }
    },
    // 开票-按账单查询结果集处理
    handleInvoiceResult(res) {
      if (res.data.list && res.data.list.length > 0) {
        this.rowData = res.data.list
        this.searchConditions.total = Number(res.data.total)
        this.totalAmountToCurrencyBillingGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyBillingGrid.selectedCount = 0
      } else {
        this.rowData = []
        this.searchConditions.total = 0
        this.totalAmountToCurrencyBillingGrid.dataProvider = []
        this.totalAmountToCurrencyBillingGrid.selectedCount = 0
      }
    },
    // 追加自定义查询条件
    async initCustomSearchItems() {
      const defaultSearchFields = []
      // 账单业务状态配置项
      if (this.viewSource !== 'VoucherList') this.searchConditions.jobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.billingJobStateParam, SystemConstants.JOB_STATES)
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemValue = []
        searchField.itemLabel = 'Billing.billingCharge_businessStatus'
        searchField.itemName = 'job.JOB_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.jobStates
        searchField.action = 2
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // CARGO-47346 整拼类型
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'containerLoadTypeCascader'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST_ALL_LOB'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = 'IN'
      searchField.itemName = 'containerLoadTypeForAll'
      searchField.itemLabel = 'CargoMsg.Cargo_BusinessModel'
      searchField.defaultValue = []
      searchField.action = AdvancedSearchField.ADD_ACTION
      defaultSearchFields.push(searchField.formatObj2Json())

      // 账单状态配置项
      if (this.viewSource !== 'VoucherList' && this.viewSource !== 'tabBilling') this.searchConditions.billingStates = await LoadDefaultQueryParam.getConfigQueryParam(this.billingStateParam, BillingConstants.BILLING_STATES)
      if (this.searchConditions.billingStates && this.searchConditions.billingStates.length > 0) {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemValue = []
        searchField.itemLabel = 'Billing.billingJob_billStatus'
        searchField.itemName = 'billing.STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.dataProvider = this.searchConditions.billingStates
        searchField.action = 2
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 默认结算单位
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'Billing.billingJob_settlementCompany'
          searchField.itemName = 'billing.ACCOUNTID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 是否已核销
      if (this.viewSource === 'Writeoff') {
        const searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge.PAID_OFF'
        searchField.itemLabel = 'Billing.billingJob_wroteOff'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 销账-是否已开票(销账)
        if ([0, 1].includes(this.writeoffHasInvoice)) {
          const searchField = new AdvancedSearchField()
          searchField.action = 2
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_IS_NOT_NULL'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'charge.INVOICE_UUID'
          searchField.itemLabel = 'Billing.billingJob_invoicedOrNot'
          searchField.selected = 1
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          searchField.lock = true
          searchField.defaultValue = this.writeoffHasInvoice === 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 是否已申请付款(销账)
        if ([0, 1].includes(this.invoiceHasBillPayment)) {
          const searchField = new AdvancedSearchField()
          searchField.action = 2
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_IS_NOT_NULL'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'charge.BILL_PAYMENT_UUID'
          searchField.itemLabel = 'Billing.billingJob_billPaymentOrNot'
          searchField.selected = 1
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          searchField.lock = true
          searchField.defaultValue = this.invoiceHasBillPayment === 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 我方银行名称
      if (this.viewSource === 'tabBilling') {
        const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
        this.bankList = []
        // 银行名称和银行账号要去重
        const bankList = []
        if (res.data && res.data.length > 0) {
          for (const item of res.data) {
            this.bankList.push(item)
            const bank = item.bankChineseName
            if (bankList.length === 0) {
              bankList.push(item)
            } else {
              const index = bankList.findIndex(p => p.bankChineseName === bank)
              if (index < 0) {
                bankList.push(item)
              }
            }
          }
        }
        // 我方银行名称
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'advanceSelect'
        searchField.multiple = 0
        searchField.action = 2
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemValue = []
        searchField.itemLabel = 'Invoice.invoice_sp8'
        searchField.itemName = 'bankAccount.BANK_CHINESE_NAME'
        searchField.headers = [this.$t('Clearing.BankName')]
        searchField.fields = ['bankChineseName']
        searchField.tagName = 'bankChineseName'
        searchField.tagValue = 'bankChineseName'
        searchField.dataCacheKey = 'static_data_BankAccount'
        searchField.dataProvider = bankList
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // CARGO-37600 H5 BUG 筛选条件保存多个无法保存成功
      // // 账单确认人
      // const searchField = new AdvancedSearchField()
      // searchField.action = AdvancedSearchField.UPDATE_ACTION
      // searchField.itemType = 'advanceSelect'
      // searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      // searchField.itemName = 'billing.CONFIRM_USER'
      // searchField.itemLabel = 'CargoMsg.Carge_BillingConfirmUser'
      // searchField.tagValue = 'userId'
      // searchField.defaultSelected = 0
      // searchField.subType = { filterable: true }
      // searchField.dataProvider = getCacheListByKey(basicCacheKeys.basic_data_User)
      // defaultSearchFields.push(searchField.formatObj2Json())
      if (this.newInvoiceTypesOfBilling) {
        const searchField = new AdvancedSearchField()
        searchField.action = 2
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'billing.INVOICE_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_InvoiceType'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = 'InvoiceConstant.BILLING_INVOICE_TYPES_CJ'
        searchField.dataCacheKey = 'local_cache_InvoiceConstant$BILLING_INVOICE_TYPES_CJ'
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // CARGO-26075，预收核销
      if (this.toExoSystemOC) {
        const searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'billing.PRE_PAYMENT'
        searchField.itemLabel = 'CargoMsg.Cargo_OcPrePayment'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.isBpmEnabled) {
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // CARGO-47698 参数=0时 查询页签，展示账单类型，并锁定，只能查询【国外账单】
      if (Number(cache.config.get('VocherAllowedQueryDomesticBilling')) !== 1) {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'billing.BILLINGTYPE'
        searchField.itemLabel = 'Billing.billingView_billType'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = true
        searchField.defaultValue = ''
        searchField.dropdownDataRef = 'BillingConstants.BILLING_TYPE2'
        searchField.dataCacheKey = 'local_cache_BillingConstants$BILLING_TYPE2'
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (this.qlToFinanceApi) {
        // 同步云平台状态
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_IN.code
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'billing._qlPushExternalInterfaceStatus_'
        searchField.itemLabel = 'Clearing.SyncCloudPlatformStatus'
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.QL_KD_SYNC_STATUS
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      } else {
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'billing._qlPushExternalInterfaceStatus_'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }

      if (defaultSearchFields && defaultSearchFields.length > 0) {
        this.customSearchItems = this.customSearchItems.concat(defaultSearchFields)
      }
      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, this.customSearchItems)
      }
    },
    onRowSelected(event) {
      if (!event.data) {
        return
      }
      this.selectedItem = {}
      // CARGO-18472 多次查看账单后，提示接口调用错误 请联系在线客服(原因：针对于列表开始先勾选两个，然后取消一个的场景下，event.node.selected=false.此时要根据getGridSelected获取列表选中行，取第一个)
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      } else {
        if (this.gridOptions) {
          const selections = getGridSelected(this.gridOptions)
          if (selections.length > 0) {
            this.selectedItem = selections[0]
          }
        }
      }
    },
    onRowClicked(event) {
      if (!event.data) {
        return
      }
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
      this.$emit('onRowClicked', this.selectedItem)
    },
    onRowDoubleClicked(event) {
      if (!event.data) {
        return
      }
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCount() {
      console.log('toRefreshSelectedCount')
      this.filterChange()
      // this.once.excute(this.refreshSelectedCount, [], 200)
    },
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed && node.data) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyBillingGrid.selectionCountLabel = this.$t('Clearing.Selected') + selections.length + '：'
        this.totalAmountToCurrencyBillingGrid.dataProvider = selections
      } else if (arg == 1) {
        this.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGrid.dataProvider = selections
      } else {
        this.totalAmountToCurrencyBillingGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillingGrid.dataProvider = this.rowData
      }
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-billing')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    updateRealtotal(realtotal) {
      this.$refs.paginationBilling.realtotal = realtotal
    },
    // 获取多选选中行
    getSelections() {
      return getGridSelected(this.gridOptions)
    },
    // 是否红冲
    isRedPunch() {
      return false
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    onView(value) {
      this.pushLogDialog.visible = true
      this.pushLogDialog.uuid = value
    }
  }
}
</script>
